import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Paper,
  Link,
  Container,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import imgUrl from '../../assets/images/imgUrl';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const imgUrls = [
  imgUrl.fincirc,
  imgUrl.balpharma,
  imgUrl.ecube,
  imgUrl.whiteSpoons,
  imgUrl.pharmveda,
  imgUrl.chablani,
  imgUrl.enersynk,
  imgUrl.pecan,
  imgUrl.kridzz,
  imgUrl.deal,
  imgUrl.blackSwan,
  imgUrl.kurves,
  imgUrl.siroya,
  imgUrl.stivaph,
];

const data = {
  tiers: [
    { name: 'Platinum', price: '$12,000' },
    { name: 'Gold', price: '$7,000' },
    { name: 'Silver', price: '$4,000' },
    { name: 'Bronze', price: '$2,100' },
  ],
  benefits: [
    {
      category: 'Stage Felicitation',
      items: [{ label: 'With I Am Peacekeeper Chief Guests', values: ['Yes', 'Yes', 'No', 'No'] }],
    },
    {
      category: 'Logo at Event',
      items: [
        { label: 'Static throughout the event', values: ['2', '2', '1', '1'] },
        { label: 'Appears digitally on screen', values: ['5', '4', '3', '1'] },
        { label: 'Total', values: ['7', '6', '4', '2'] },
      ],
    },
    {
      category: 'Online Mentions',
      items: [
        { label: 'IAPM Website', values: ['Yes', 'Yes', 'Yes', 'Yes'] },
        { label: 'IAPM Social Media', values: ['Yes', 'Yes', 'No', 'No'] },
      ],
    },
    {
      category: 'Press Release',
      items: [{ label: 'Released with Press Note', values: ['Yes', 'Yes', 'No', 'No'] }],
    },
    {
      category: 'Stall',
      items: [{ label: 'Allocated Exclusive Stall', values: ['Yes', 'No', 'No', 'No'] }],
    },
    {
      category: 'Exclusive Session',
      items: [
        {
          label: (
            <>
              Coffee & Conversation with <br />
              Professor Mohan Munasinghe <br />
              (5:30–6:30 PM GST <br />
              Taj Business Bay)
            </>
          ),
          values: ['Yes', 'No', 'No', 'No'],
        },
      ],
    },
  ],
};

const guests = [

  {
    name: 'Dr. Asle Toje',
    description:
      <>
        <b>Vice Chair (Deputy Leader),</b>  <i>Norwegian Nobel Committee</i> ; <b>Member</b> <b>2018–2029</b> ; former <b>Research Director,</b>
        <i>Norwegian Nobel Institute</i>.
      </>

  },
  {
    name: 'His Excellency Sheikh Awad Mohammed bin Sheikh Mejren',
    description: <>
      <b> Founder, </b> <i>Emirates Travellers </i>  🌍; <b>Chairman,</b> <i>Emirates Travellers Festival</i>.
    </>
  },
  {
    name: 'His Excellency Dr. Khalid Ghanem Al Ghaith',
    description:
      <>
        <b>Secretary-General,</b> <i>Higher Committee of Human Fraternity (HCHF) Abu Dhabi</i>
      </>

  },
  {
    name: 'His Excellency Mirza Hussain Al Sayegh',
    description:
      <>
        <b>Member,</b> <i>Board of Trustees, Al Maktoum Foundation, UAE;</i> <b>Chairman,</b> <i>Al-Maktoum College of Higher Education, Dundee (UK)</i>
      </>

  },
  {
    name: 'His Excellency Dr. Mohammed Saeed Al Kindi',
    description:
      <>
        former <b>Minister of Environment and Water</b> <i>UAE</i>
      </>

  },
  {
    name: 'Professor Mohan Munasinghe - 2007',
    description: <>
      <i>Nobel Peace Prize </i> <b> Co-Laureate (Vice-Chair,</b> <i>IPCC</i>) ; <b>2021 </b> <i>Blue Planet Prize  🌊</i>; <b>Founder-Chairman, </b>
      <i>MIND</i>.
    </>
  },
  {
    name: 'Honourable Ms. Ouided Bouchamaoui',
    description: <>
      <b>2015 </b> <i>Nobel Peace Laureate  (Tunisian National Dialogue Quartet)</i>; Former <b>President</b>, <i>UTICA</i> .
    </>
  },
  {
    name: 'Dr. Siddeek Ahmed',
    description:
      <>
        <b>Chairman & Managing Director, </b><i>Eram Holdings; </i> <b>Co-Chair</b> <i>FICCI Arab Council</i> <b>2021</b> <i>Pravasi Bharatiya Samman Award</i> <b>winner.</b>
      </>
  },
  {
    name: 'His Excellency Yaqoob Al Ali',
    description:
      <>
        <b>Executive Director & Private Advisor</b> <i>Office of His Highness Sheikh Juma Bin Maktoum Al Maktoum</i> ; <b>Executive Chairman</b> <i>Al Ali Group (UAE).</i>
      </>
  },
];

const platinumAccounts = [
  {
    subTitle: 'For USD Payments',
    details: [
      'Bank Name: First Abu Dhabi Bank PJSC (FAB)',
      'Account Number: 1001326744366002',
      'IBAN: AE580351001326744366002',
      'Currency: USD',
      'SWIFT/Code: NBADAEAA',
      'Branch: Sheikh Zayed Road, Al Quoz 3, Dubai, UAE',
    ],
  },
  {
    subTitle: 'For AED Payments',
    details: [
      'Bank Name: First Abu Dhabi Bank PJSC (FAB)',
      'Account Number: 1001326744366001',
      'IBAN: AE850351001326744366001',
      'Currency: AED',
      'SWIFT/Code: NBADAEAA',
      'Branch: Sheikh Zayed Road, Al Quoz 3, Dubai, UAE',
    ],
  },
];

const otherTiersAccounts = [
  {
    subTitle: 'For USD Payments',
    details: [
      'Name of Bank:  WIO PJSC',
      'Account Holder: JUPITER EVENTS L.L.C',
      'IBAN: AE840860000009332725809',
      'BIC/SWIFT: WIOBAEADXXX',
      'Business Address: Etihad Airways Centre, 5th Floor Abu Dhabi, UAE',
      'Al Ittihad Road, Deira, Dubai, UAE',
      'Correspondent Bank Name: Citibank',
      'NABIC/SWIFT Code: CITIUS33XXX',
    ],
  },
  {
    subTitle: 'For AED Payments',
    details: [
      'Name of Bank: WIO PJSC',
      'Account Holder: JUPITER EVENTS L.L.C',
      'IBAN: AE760860000009366914864',
      'BIC/SWIFT:  WIOBAEADXXX',
      'Business Address:  Etihad Airways Centre, 5th Floor Abu Dhabi, UAE'

    ],
  },
];

const PaymentSection = ({ title, accounts }) => (
  <div sx={{ mt: 4 }}>
    {title && (
      <Typography gutterBottom>
        {title}
      </Typography>
    )}
    {accounts.map((acc, idx) => (
      <div key={idx} sx={{ mt: 1, pl: 2 }}>
        <Typography fontWeight="bold" gutterBottom>
          {acc.subTitle}
        </Typography>
        <List dense sx={{ pl: 2 }}>
          {acc.details.map((item, index) => (
            <ListItem key={index} sx={{
              alignItems: 'flex-start',
              p: 0,
              '&::before': {
                content: '"•"',
                color: '#333',
                fontSize: '1.2rem',
                display: 'inline-block',
                width: '1rem',
                marginRight: '0.5rem',
              },
            }}>
              <ListItemText primary={<Typography variant="body2">{item}</Typography>} />
            </ListItem>
          ))}
        </List>
      </div>
    ))}
  </div>
);

const Events = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>


      {/* Event Hero Background */}
      <Box
        className="programEventSectionBg commonBannerBg"
        sx={{
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          px: { xs: 1, sm: 2 },
          minHeight: { xs: 160, sm: 220, md: 300 },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: 70, sm: 75, md: 80 },
            left: 0,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: { xs: 120, sm: 160, md: 200 } }}
          />
        </Box>
      </Box>


      {/* Events Timeline */}
      <Box mt={{ xs: 3, sm: 4, md: 5 }} sx={{ px: { xs: 1, sm: 2 }, overflow: 'hidden' }}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item xs={12} display="flex" flexDirection="column" alignItems="center" sx={{ px: { xs: 1, sm: 2 } }}>
            <Box
              component="img"
              src={imgUrl.peaceIcon}
              alt="Peace Icon"
              className="w-100 peaceImg"
              sx={{ maxWidth: { xs: 50, sm: 60, md: 70 } }}
            />
            <Typography
              variant="h1"
              className="founder-title mainHeading green-title"
              sx={{
                fontFamily: 'var(--heading-font)',
                fontWeight: 400,
                fontSize: { xs: '1.5rem', sm: '1.875rem', md: '2.25rem', lg: '2.5rem' },
                textAlign: 'center',
                wordBreak: 'break-word',
              }}
            >
              I Am Peacekeeper Events
            </Typography>
          </Grid>
        </Grid>

        <Box className="waveBg event-ProgramSection" mt={{ xs: 2, sm: 3 }} sx={{ overflow: 'hidden' }}>
          <Box
            className="timeline-container"
            sx={{
              width: '100%',
              maxWidth: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              px: { xs: 1, sm: 2, md: 3 },
              overflow: 'hidden',
            }}
          >
            {/* Event Cards */}
            {[{
              link: "https://billionaires-for-peace.com/",
              month: "May, 2026",
              day: "21st",
              img: imgUrl.billionaireLogo,
              desc: `Forthcoming Prestige Conclave\nThursday, 21st May 2026 — Billionaires for Peace Conclave , Dubai\n7 Nobel Peace Laureates; Gala Dinner; I Am Peacekeeper Charter.\n`,
            }, {
              link: "https://i-am-peacekeeper.com/",
              day: "4th",
              month: "Sept, 2025",

              img: imgUrl.peaceMovImg,
              desc: `Momentous Launch\nThursday, 4th September 2025 — I Am Peacekeeper Movement , Dubai, 1:47 PM GST\nWebsite and App launch (Opera Ballroom, Taj Business Bay).`,
            }, {
              link: "https://justice-love-peace.com/",
              month: "April, 2025",
              day: "12th & 13th",
              img: imgUrl.justiceLogo,
              desc: `Landmark Occasion\nSaturday, 12th April 2025 and Sunday, 13th April 2025 — Global Justice, Love & Peace Summit, Dubai Expo City\n10 Nobel Peace Laureates; Peace Charter presented.`,
            }].map((event, idx) => (
              <React.Fragment key={idx}>
                {/* Render circle outside card only for 4th Sept (idx === 1) */}
                {/* {idx === 1 && (
                  <Link href={event.link} target="_blank" className="cursor-pointer text-decoration-none">
                    <Paper
                      elevation={3}
                      className="event-card"
                      sx={{ width: { xs: '75vw', sm: 'min(250px, 85vw)' }, maxWidth: 250 }}
                    >
                      <Box className="circle-wrapper">
                        <Box className="date-circle yellow">
                          <Typography variant="h5" className="day">{event.day}</Typography>
                          <Typography variant="h6" className="month">{event.month}</Typography>
                        </Box>
                      </Box>
                      <Box className="event-content">
                        <div className="eventImg"><img src={event.img} /></div>
                        <Typography variant="body1" className="event-description">{event.desc}</Typography>
                      </Box>
                    </Paper>
                  </Link>
                )} */}
                {/* Global Justice, Love & Peace Content Section - After third event */}
                {idx === 2 && (
                  <Box
                    className="globalEventcircle"
                    sx={{
                      width: '100%',
                      maxWidth: { xs: '100%', sm: '800px', md: '900px', lg: '1200px', xl: '1400px' },
                      mx: 'auto',
                      mb: { xs: 4, sm: 5, md: 2 },
                      px: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: { xs: '12px', sm: '16px', md: '20px' },
                        padding: { xs: 3, sm: 4, md: 5 },
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        border: '1px solid #e9ecef',
                      }}
                    >
                      {/* Event Circle Inside Card */}
<Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          mb: 3,
                        }}
                      >
                        <Link
                          href={event.link}
                          target="_blank"
                          className="cursor-pointer text-decoration-none"
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                              <Paper
                                elevation={3}
                                className="event-card"
                                sx={{ width: { xs: '75vw', sm: 'min(250px, 85vw)' }, maxWidth:"400px" }}
                              >
                            <Box className="circle-wrapper">
                              <Box className="date-circle yellow">
                                <Typography variant="h5" className="day">{event.day}</Typography>
                                <Typography variant="h6" className="month">{event.month}</Typography>
                              </Box>
                            </Box>
                            <Box className="event-content">
                              <div className="eventImg"><img src={event.img} /></div>
                              <Typography variant="body1" className="event-description">{event.desc}</Typography>
                            </Box>
                          </Paper>
                        </Link>
                      </Box>

                      {/* Title */}
                      <Typography
                        variant="h1"
                        sx={{
                          fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                          fontWeight: 400,
                          fontFamily: 'var(--heading-font)',
                          color: '#0A8270',
                          mb: 3,
                          textAlign: 'center',
                          lineHeight: 1.2,
                        }}
                      >
                        Global Justice, Love & Peace
                      </Typography>

                      {/* Opening Quote */}
                      <Typography
                        variant="h2"
                        sx={{
                          fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.35rem' },
                          fontStyle: 'italic',
                          color: '#43454b',
                          mb: 4,
                          textAlign: 'center',
                          fontFamily: 'var(--default-font)',
                          lineHeight: 1.6,
                          fontWeight: 400,
                        }}
                      >
                        Some gatherings feel like meetings. This one felt like a turning.
                      </Typography>

                      {/* Main Content */}
                      <Box sx={{ mb: 4 }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'center',
                            fontWeight: 400,
                          }}
                        >
                          On Saturday and Sunday, 12–13 April 2025, the Global Justice, Love & Peace Summit came alive at the Dubai Exhibition Centre (DEC) at Expo City, Dubai, from 10 AM to 11 PM. Chaired by Dr. Huzaifa Khorakiwala and honoured by H.E. Sheikh Nahyan bin Mubarak Al Nahyan, UAE Minister of Tolerance and Co-existence, the Summit welcomed an international constellation of speakers and delegates for two days of dialogue, reflection and connection.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'center',
                            fontWeight: 400,
                          }}
                        >
                          Across sessions on Justice, Love & Peace, we explored how societies heal, how communities listen and how leaders serve without losing their humanity. Alongside the conversations, a special meditation session and a world yoga session created space to breathe, reset and remember what we are building together.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'center',
                            fontWeight: 400,
                          }}
                        >
                          At the heart of it all stood our shared compass: <strong>Truth, Gratitude, Forgiveness, Love, Humility, Giving and Patience</strong>. These are not slogans, they are practices and this Summit was our first major step in living them publicly and purposefully.
                        </Typography>
                      </Box>

                      {/* Closing Statement */}
                      <Box
                        sx={{
                          borderTop: '2px solid #d1de5f',
                          borderBottom: '2px solid #d1de5f',
                          py: 1,
                          mt: 4,
                          mb: 3,
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' },
                            fontWeight: 600,
                            textAlign: 'center',
                            fontFamily: 'var(--heading-font)',
                            lineHeight: 1.6,
                          }}
                        >
                          The closing lesson was simple: peace is not a conclusion, it is a daily craft.
                        </Typography>
                      </Box>

                      {/* Final Line */}
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                          color: '#666',
                          textAlign: 'center',
                          fontFamily: 'var(--secondary-font) !important',
                          lineHeight: 1.6,
                          fontStyle: 'italic',
                          fontWeight: 400,
                        }}
                      >
                        The work continues, quietly, steadily and together.
                      </Typography>
                      
                      {/* Link */}
                      <Box sx={{ mt: 2, textAlign: 'center' }}>
                        <Link
                          href="https://www.justice-love-peace.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                            textDecoration: 'none',
                            fontFamily: 'var(--secondary-font)',
                            fontWeight: 500,
                            color: 'black',
                            '&:hover': {
                              textDecoration: 'underline',
                            },
                          }}
                        >
                          www.justice-love-peace.com
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                )}
                {/* I Am Peacekeeper Movement & Global Initiatives Content Section - After second event */}
                {idx === 1 && (
                  <Box
                    className="globalEventcircle"
                    sx={{
                      width: '100%',
                      maxWidth: { xs: '100%', sm: '800px', md: '900px', lg: '1200px', xl: '1400px' },
                      mx: 'auto',
                      mb: { xs: 4, sm: 5, md: 6 },
                      px: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 },
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: { xs: '12px', sm: '16px', md: '20px' },
                        padding: { xs: 3, sm: 4, md: 5 },
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        border: '1px solid #e9ecef',
                      }}
                    >
                      {/* Event Circle Inside Card */}
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          mb: 3,
                        }}
                      >
                        <Link
                          href={event.link}
                          target="_blank"
                          className="cursor-pointer text-decoration-none"
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          <Paper
                            elevation={3}
                            className="event-card"
                            sx={{ width: { xs: '75vw', sm: 'min(250px, 85vw)' }, maxWidth: 250 }}
                          >
                            <Box className="circle-wrapper">
                              <Box className="date-circle yellow">
                                <Typography variant="h5" className="day">{event.day}</Typography>
                                <Typography variant="h6" className="month">{event.month}</Typography>
                              </Box>
                            </Box>
                            <Box className="event-content">
                              <div className="eventImg"><img src={event.img} /></div>
                              <Typography variant="body1" className="event-description">{event.desc}</Typography>
                            </Box>
                          </Paper>
                        </Link>
                      </Box>

                      {/* Title */}
                      <Typography
                        variant="h1"
                        sx={{
                          fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                          fontWeight: 400,
                          fontFamily: 'var(--heading-font)',
                          color: '#0A8270',
                          mb: 3,
                          textAlign: 'center',
                          lineHeight: 1.2,
                        }}
                      >
                        I Am Peacekeeper Movement & Global Initiatives
                      </Typography>

                      {/* Opening Quote */}
                      <Typography
                        variant="h2"
                        sx={{
                          fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.35rem' },
                          fontStyle: 'italic',
                          color: '#43454b',
                          mb: 4,
                          textAlign: 'center',
                          fontFamily: 'var(--default-font)',
                          lineHeight: 1.6,
                          fontWeight: 400,
                        }}
                      >
                        Building peace from the ground up, one commitment at a time.
                      </Typography>

                      {/* Main Content */}
                      <Box sx={{ mb: 4 }}>                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'center',
                            fontWeight: 400,
                          }}
                        >
                          Launched on the 4th of September 2025 in Dubai, the I Am Peacekeeper Movement is a global platform dedicated to spreading <strong>Truth, Gratitude, Forgiveness, Love, Humility, Giving and Patience</strong> across every community and every nation.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'center',
                            fontWeight: 400,
                          }}
                        >
                          Through strategic Global Initiatives, partnerships and ground-level programs, the Movement creates tangible pathways for individuals, organizations and nations to embrace these core values. Our Chief Guests—thought leaders, changemakers and visionaries—guide this mission with their wisdom and commitment to measurable peace.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'center',
                            fontWeight: 400,
                          }}
                        >
                          This is the movement for our time: grounded in practice, rooted in values, scaled for impact.
                        </Typography>
                      </Box>

                      {/* Closing Statement */}
                      <Box
                        sx={{
                          borderTop: '2px solid #d1de5f',
                          borderBottom: '2px solid #d1de5f',
                          py: 1,
                          mt: 4,
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' },
                            fontWeight: 600,
                            textAlign: 'center',
                            fontFamily: 'var(--heading-font)',
                            lineHeight: 1.6,
                          }}
                        >
                          Join the I Am Peacekeeper Movement: where values meet vision and commitment becomes action.
                        </Typography>
                        
                      </Box>
                       <Typography
                        variant="body2"
                        sx={{
                          fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                          color: '#666',
                          textAlign: 'center',
                          fontFamily: 'var(--secondary-font) !important',
                          lineHeight: 1.6,
                          fontStyle: 'italic',
                          fontWeight: 400,
                        }}
                      >
                        Peace is not a destination. It is a practice.
                      </Typography>

                      {/* Link */}
                      <Box sx={{ mt: 2, textAlign: 'center' }}>
                        <Link
                          href="https://www.i-am-peacekeeper.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                            color: 'black',
                            textDecoration: 'none',
                            fontFamily: 'var(--secondary-font)',
                            fontWeight: 500,
                            '&:hover': {
                              textDecoration: 'underline',
                              color: '#0b8270',
                            },
                          }}
                        >
                          www.i-am-peacekeeper.com
                        </Link>
                      </Box>
                      <Box
                        component="hr"
                        sx={{
                          width: { xs: '80%', sm: '60%', md: '50%' },
                          mx: 'auto',
                          border: 'none',
                          borderTop: '1px solid #e0e0e0',
                          my: 3,
                        }}
                      />
<Box
            sx={{
              textAlign: 'center',
              p: { xs: 2, sm: 3, md: 4 },
              overflow: 'hidden',
            }}
            className="peacekeeperPatronSection"
          >
          {/* Peacekeeper PATRON Section */}
          <Typography
            variant="h2"
            className="patronHeading green-title"
            sx={{
              color: 'black',
              fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
              lineHeight: 1.3,
              mb: 1,
            }}
          >
            Official Advocates
            <br />
            I Am Peacekeeper Movement & Global Initiatives
          </Typography>
          <Typography sx={{ mb: 2, fontSize: { xs: '0.9rem', sm: '1rem' } }}>
            Thursday, 4th September 2025, Dubai
          </Typography>
          {/* <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
          {renderCircles(5)}
        </Grid> */}

          {/* Peacekeeper PARTNER Section */}
          {/* <img src={imgUrl.peaceIcon} className='w-100 peaceImg' mt={5}></img>
        <Typography variant="h6" sx={{ mb: 1 }} className='patronHeading green-title'>
          I Am Peacekeeper PARTNER:
         <br></br>
        
          Partners of Global Justice, <br></br> Love & Peace
          </Typography>
        <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
          {renderCircles(5)}
        </Grid> */}

          {/* logos partner section */}


          <Box
            className="partnerOne"
            sx={{
              mb: { xs: 3, sm: 4 },
              overflow: 'hidden',
            }}
          >
            <Box className="logosPartners platinum" sx={{ py: { xs: 1, sm: 1.5 }, px: { xs: 1, sm: 2 } }}>
              <Typography sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' } }}>🏆 Platinum</Typography>
            </Box>

            <Box className="platinumPartners" sx={{ flexWrap: 'wrap', gap: { xs: 2, sm: 3 }, px: { xs: 1, sm: 2 }, py: 2 }}>
              <LazyLoadImage
                key={1}
                src={`${imgUrl.microlab}`}
                alt={`Image Alt-logo`}
                className="media"
                placeholderSrc={""}
                effect="blur" // opacity | black-and-white
              />

              <LazyLoadImage
                key={2}
                src={`${imgUrl.globalProperty}`}
                alt={`Image Alt-logo`}
                className="media pixelSmallImage"
                placeholderSrc={""}
                effect="blur" // opacity | black-and-white
              />
              {/* <img src={imgUrl.microlab} alt='logo' loading="lazy"></img>
              <img src={imgUrl.globalProperty} alt='logo' loading="lazy"></img> */}
            </Box>
          </Box>

          <Box className="partnerOne nextRow" sx={{ overflow: 'hidden' }}>
            <Box className="logosPartners silver" sx={{ py: { xs: 1, sm: 1.5 }, px: { xs: 1, sm: 2 } }}>
              <Typography sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.875rem' } }}>🥈 Silver</Typography>
            </Box>

            <Box className="platinumPartners" sx={{ flexWrap: 'wrap', gap: { xs: 2, sm: 3 }, px: { xs: 1, sm: 2 }, py: 2 }}>

              <LazyLoadImage
                key={1}
                src={`${imgUrl.bhima}`}
                alt={`Image Alt-logo`}
                className="media pixelSmallImage"
                placeholderSrc={""}
                effect="blur" // opacity | black-and-white
              />

              <LazyLoadImage
                key={1}
                src={`${imgUrl.shukra}`}
                alt={`Image Alt-logo`}
                className="media shukraLogo"
                placeholderSrc={""}
                effect="blur" // opacity | black-and-white
              />
              {/* <img src={imgUrl.bhima}  alt='logo' loading="lazy"></img>
              <img src={imgUrl.shukra}  alt='logo'></img> */}
            </Box>
          </Box>

          <Box className="partnerOne nextRow" sx={{ overflow: 'hidden' }}>
            <Box className="logosPartners bronze" sx={{ py: { xs: 1, sm: 1.5 }, px: { xs: 1, sm: 2 } }}>
              <Typography sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.875rem' } }}>🥉 Bronze</Typography>
            </Box>

            <Box className="platinumPartners bronzeLogos" sx={{ px: { xs: 1, sm: 2 }, py: 2 }}>
              <Grid container alignItems="center" justifyContent="center" spacing={{ xs: 1.5, sm: 2 }} className="mobileGrid">
                {imgUrls.slice(0, 7).map((logo, index) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
                    {/* <img src={logo} alt={`logo-${index}`}/> */}

                    <LazyLoadImage
                      key={index}
                      src={`${logo}`}
                      alt={`Image Alt-logo`}
                      className="media"
                      placeholderSrc={""}
                      effect="blur" // opacity | black-and-white
                    />
                  </Grid>
                ))}

              </Grid>
              <Grid container justifyContent="center" spacing={{ xs: 1.5, sm: 2 }} className="mobileGrid">
                {imgUrls.slice(7, 14).map((logo, index) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
                    {/* <img src={logo} alt={`logo-${index}`}/> */}
                    <LazyLoadImage
                      key={index}
                      src={`${logo}`}
                      alt={`Image Alt-logo`}
                      className="media"
                      placeholderSrc={""}
                      effect="blur" // opacity | black-and-white
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>

          <Box className="partnerOne nextRow" sx={{ overflow: 'hidden' }}>
            <Box className="logosPartners itPartners" sx={{ py: { xs: 1, sm: 1.5 }, px: { xs: 1, sm: 2 } }}>
              <Typography sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.875rem' } }}>🖥️ IT Partner</Typography>
            </Box>

            <Box className="platinumPartners dureLogo" sx={{ px: { xs: 1, sm: 2 }, py: 2 }}>
              {/* <img src={imgUrl.dure}  alt='logo' loading="lazy"></img> */}
              <LazyLoadImage
                key={11}
                src={`${imgUrl.dure}`}
                alt={`Image Alt-logo`}
                className="media"
                placeholderSrc={""}
                effect="blur" // opacity | black-and-white
              />
            </Box>
          </Box>
        </Box>

                      {/* Final Line */}
                     
                    </Box>
                  </Box>
                )}
                {/* Billionaires for Peace Content Section - After first event */}
                {idx === 0 && (
                  <Box
                    className="globalEventcircle"
                    sx={{
                      width: '100%',
                      maxWidth: { xs: '100%', sm: '800px', md: '900px', lg: '1200px', xl: '1400px' },
                      mx: 'auto',
                      mb: { xs: 4, sm: 5, md: 6 },
                      px: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: { xs: '12px', sm: '16px', md: '20px' },
                        padding: { xs: 3, sm: 4, md: 5 },
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        border: '1px solid #e9ecef',
                      }}
                    >
                      {/* Event Circle Inside Card */}
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          mb: 3,
                        }}
                      >
                        <Link
                          href={event.link}
                          target="_blank"
                          className="cursor-pointer text-decoration-none"
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          <Paper
                            elevation={3}
                            className="event-card"
                            sx={{ width: { xs: '75vw', sm: 'min(250px, 85vw)' }, maxWidth: 250 }}
                          >
                            <Box className="circle-wrapper">
                              <Box className="date-circle yellow">
                                <Typography variant="h5" className="day">{event.day}</Typography>
                                <Typography variant="h6" className="month">{event.month}</Typography>
                              </Box>
                            </Box>
                            <Box className="event-content">
                              <div className="eventImg"><img src={event.img} /></div>
                              <Typography variant="body1" className="event-description">{event.desc}</Typography>
                            </Box>
                          </Paper>
                        </Link>
                      </Box>

                      {/* Title */}
                      <Typography
                        variant="h1"
                        sx={{
                          fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                          fontWeight: 400,
                          fontFamily: 'var(--heading-font)',
                          color: '#0A8270',
                          mb: 3,
                          textAlign: 'center',
                          lineHeight: 1.2,
                        }}
                      >
                        Billionaires for Peace Conclave
                      </Typography>

                      {/* Main Content */}
                      <Box sx={{ mb: 4 }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: { xs: 'left', sm: 'center', md: 'justify' },
                            fontWeight: 400,
                          }}
                        >
                          In May 2026, Dubai becomes a meeting place for the world's most resourced minds and the world's most urgent prayer: peace that is measurable, practical and real. The Billionaires for Peace Conclave is the annual gathering of the I Am Peacekeeper Movement, created to advance World Peace and Inner Peace through a clear method: one conclave each year supported by research papers, advocacy and action with impact measured objectively every quarter.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'center',
                            fontWeight: 400,
                          }}
                        >
                          This is a deliberately limited circle. The first 210 billionaires who accept the invitation are recognised as the Legacy Circle, joining a network designed for meaningful connection with Nobel Peace Laureates and fellow I Am Peacekeeper billionaire patrons.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: 'justify',
                            fontWeight: 400,
                          }}
                        >
                          The Conclave carries a simple moral architecture: <strong>Truth, Gratitude, Forgiveness, Love, Humility, Giving and Patience</strong> as guiding lights for decision-making and service.
                        </Typography>

                        

                        {/* Link */}
                        
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--primary-font)',
                            lineHeight: 1.8,
                            textAlign: { xs: 'left', sm: 'center', md: 'justify' },
                            fontWeight: 400,
                          }}
                        >
                          A signature moment of the Conclave is the I Am Peacekeeper Crown and Champion Award ceremony, nominated by the Governing Council chaired by Dr. Huzaifa Khorakiwala and presented by 4 Nobel Peace Laureates in person in a path-breaking investiture at the Grand Hyatt, Dubai subject to the awardee's presence.
                        </Typography>
                      </Box>

                      {/* Closing Statement */}
                      <Box
                        sx={{
                          borderTop: '2px solid #d1de5f',
                          borderBottom: '2px solid #d1de5f',
                          py: 1,
                          mt: 4,
                          mb: 3,
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' },
                            fontWeight: 600,
                            textAlign: 'center',
                            fontFamily: 'var(--heading-font)',
                            lineHeight: 1.6,
                          }}
                        >
                          This is the invitation at the heart of it: when influence meets conscience, generosity can become strategy. Strategy can become healing.
                        </Typography>
                      </Box>
                      <Typography
                          variant="body1"
                           sx={{
                          fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                          color: '#666',
                          textAlign: 'center',
                          fontFamily: 'var(--secondary-font) !important',
                          lineHeight: 1.6,
                          fontStyle: 'italic',
                          fontWeight: 400,
                        }}
                        >
                          We are also explicitly non-religious and non-political, honouring every faith and every lawful civic alignment without turning peace into a partisan flag.
                        </Typography>
                      <Box sx={{ mb: 1, textAlign: 'center'}}>
                          <Link
                            href="https://www.billionaires-for-peace.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                              color: '#0A8270',
                              textDecoration: 'none',
                              fontFamily: 'var(--secondary-font)',
                              fontWeight: 500,
                              '&:hover': {
                                textDecoration: 'underline',
                                color: '#0b8270',
                              },
                            }}
                          >
                            www.billionaires-for-peace.com
                          </Link>
                        </Box>

                    </Box>
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Box>


      {/* Chief Guests Section */}

      <Box pb={2}>
        <Box pt={1}>
          <Box className="eventBg1 d-none" pt={4}>
            <Container maxWidth="lg" sx={{ my: 2, pb: 5 }}>
               <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
                  <img src={imgUrl.peaceIcon} className="w-100 peaceImg" />
                  <Typography variant="h1" className="founder-title mainHeading green-title" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
                    I Am Peacekeeper Movement  & <br></br> Global
                    Initiatives
                  </Typography>
                </Grid>
              </Grid>

              <Box mt={2} display="flex" alignItems="center" justifyContent="center" flexDirection="column" sx={{ maxWidth: '400px', mx: 'auto' }}>
                <img src={imgUrl.eventProfileImg} className='w-100 eventProfile' style={{ maxWidth: '300px' }}></img>
                <img src={imgUrl.eventDateImg} className='w-100 eventProfileDate' style={{ maxWidth: '300px' }}></img>
                <Typography className='eventDescription'>Precise Time - 1:47 PM GST <br></br>
                  Opera Ballroom, Taj Business Bay, Dubai</Typography>
                <div className='border-bottom-blue'></div>
              </Box>

              {/* 4th September Event Card */}
               <Box 
                sx={{ 
                  position: 'relative',
                  mt: 5,
                  mb: 4,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  px: { xs: 2, sm: 3, md: 4 },
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: { xs: -15, sm: -6, md: -2 },
                    left: { xs: '5%', sm: '21%', md: '30%' },
                    width: { xs: '80px', sm: '90px', md: '100px' },
                    height: { xs: '80px', sm: '90px', md: '100px' },
                    borderRadius: '12px',
                    backgroundColor: '#0A8270',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
                    transform: 'rotate(-8deg)',
                    zIndex: 2,
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
                      fontWeight: 700,
                      color: '#fff',
                      fontFamily: 'var(--heading-font)',
                      lineHeight: 1,
                      mb: 0.5,
                    }}
                  >
                    4th
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                      fontWeight: 600,
                      color: '#fff',
                      fontFamily: 'var(--default-font)',
                      lineHeight: 1,
                    }}
                  >
                    Sept, 2025
                  </Typography>
                </Box>

                <Box
                  component={Link}
                  href="https://i-am-peacekeeper.com/"
                  target="_blank"
                  sx={{
                    position: 'relative',
                    width: { xs: '250px', sm: '250px', md: '250px' },
                    minHeight: { xs: '250px', sm: '250px', md: '250px' },
                    borderRadius: { xs: '20px', sm: '24px', md: '28px' },
                    backgroundColor: '#006f9c69',
                    backdropFilter: 'blur(15px)',
                    WebkitBackdropFilter: 'blur(15px)',
                    border: '1px solid rgba(255, 255, 255, 0.25)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                    padding: { xs: 2.5, sm: 3, md: 3.5 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    mt: { xs: 6, sm: 7, md: 8 },
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(0, 0, 0, 0.2)',
                    },
                  }}
                >
                  {/* Logo */}
                  <Box>
                    <img 
                      src={imgUrl.peaceMovImg} 
                      alt="I Am Peacekeeper Movement"
                      style={{
                        width: '70px',
                        height: '70px',
                        objectFit: 'contain',
                      }}
                    />
                  </Box>

                  {/* I AM */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '1rem', md: '1.5rem' },
                      fontWeight: 400,
                      color: '#fff',
                      textAlign: 'center',
                      fontFamily: 'var(--default-font)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em',
                      mb: 0.5,
                    }}
                  >
                    I AM
                  </Typography>

                  {/* PEACEKEEPER */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
                      fontWeight: 700,
                      color: '#fff',
                      textAlign: 'center',
                      fontFamily: 'var(--heading-font)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      mb: 0.5,
                      lineHeight: 1.1,
                    }}
                  >
                    PEACEKEEPER
                  </Typography>

                  {/* MOVEMENT */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
                      fontWeight: 700,
                      color: '#ffff',
                      textAlign: 'center',
                      fontFamily: 'var(--heading-font)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      mb: 1,
                      lineHeight: 1.1,
                    }}
                  >
                    MOVEMENT
                  </Typography>

                  {/* Momentous Launch */}
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.125rem' },
                      fontWeight: 600,
                      color: '#07477d',
                      textAlign: 'center',
                      fontFamily: 'var(--default-font)',
                      mb: 1,
                    }}
                  >
                    Momentous Launch
                  </Typography>

                  {/* Date */}
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                      color: '#fff',
                      textAlign: 'center',
                      fontFamily: 'var(--default-font)',
                      mb: 0.5,
                    }}
                  >
                    Thursday, 4th September 2025
                  </Typography>

                  {/* Location and Time */}
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                      color: '#fff',
                      textAlign: 'center',
                      fontFamily: 'var(--default-font)',
                      mb: 0.5,
                    }}
                  >
                    Dubai, 1:47 PM GST
                  </Typography>

                  {/* Venue */}
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                      color: '#fff',
                      textAlign: 'center',
                      fontFamily: 'var(--default-font)',
                      opacity: 0.9,
                    }}
                  >
                    Opera Ballroom, Taj Business Bay
                  </Typography>
                </Box>
              </Box>
            </Container>
          </Box>
          <Box component="ul" sx={{ pl: 0, mt: 4, pt: 5 }} className="eventBg2 d-none">
            <Container maxWidth="lg" sx={{ my: 2, pb: 5 }}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
                  <img src={imgUrl.peaceIcon} className="w-100 peaceImg" />
                  <Typography variant="h5" className="founder-title mainHeading green-title">
                    <h1>I Am Peacekeeper Chief Guests</h1>
                    {/* <i>I Am Peacekeeper</i>  Chief Guests */}
                  </Typography>
                </Grid>
              </Grid>
              {guests.map((guest, index) => (
                <Box key={index} sx={{ mb: 3, mt: 3 }} className="guestTypo">
                  <Typography variant="body2" sx={{
                    '&::before': {
                      content: '"•"',
                      color: '#333',
                      fontSize: '1.2rem',
                      display: 'inline-block',
                      width: '1rem',
                      marginRight: '0.5rem',
                      marginTop: '4px'
                    },
                  }} >
                    <strong>{guest.name} - </strong> {guest.description}
                  </Typography>
                </Box>
              ))}
            </Container>
          </Box>

        </Box>

        {/* Official Advocates Section */}

        
        {/* Sponsorship Table */}
        {/* <Box sx={{  px: 2 }} pt={3} className="tableEvent eventBg3">
      <div className='border-small-bottom-blue' mb={3} mt={3}></div>
        <Container maxWidth="lg" mt={4} className='mt-50px'>
          <Typography className="subHeading" gutterBottom>
            4 clear paths to partner with impact; each tier carries stage visibility, verified digital mentions & curated networking
          </Typography>
          <TableContainer sx={{ borderRadius: 3, overflowX: 'auto', boxShadow: 3 }}>
            <Table size={isMobile ? 'small' : 'medium'} sx={{ minWidth: 600 }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#ece8f9' }}>
                  <TableCell></TableCell>
                  {data.tiers.map((tier, index) => (
                    <TableCell key={index} align="center" sx={{ fontWeight: 'bold' }}>{tier.name}</TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: '#003366' }}>
                    4<sup>th</sup> September Event Sponsorships
                  </TableCell>
                  {data.tiers.map((tier, index) => (
                    <TableCell key={index} align="center" sx={{ fontWeight: 'bold' }}>{tier.price}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.benefits.map((section, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell colSpan={5} sx={{ backgroundColor: '#21A5CC', color: 'white', fontWeight: 'bold' }}>
                        {section.category}
                      </TableCell>
                    </TableRow>
                    {section.items.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell>{item.label}</TableCell>
                        {item.values.map((value, j) => (
                          <TableCell key={j} align="center">{value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
        <div className='border-small-bottom-blue' mb={3} mt={3} style={{marginTop:"30px"}}></div>
      </Box> */}


        {/* Payment Info */}
        {/* <Box mt={5} pt={5} pb={5} className="blueEventSection eventBg3">
        <Container maxWidth="lg">
          <Box>
            <Typography fontWeight="bold" gutterBottom>
              For Platinum (US $12,000)
            </Typography>
            <PaymentSection accounts={platinumAccounts} />

           

            <Typography  fontWeight="bold" gutterBottom>
              For Gold (US $7,000), Silver (US $4,000) & Bronze (US $2,000)
            </Typography>
            <PaymentSection accounts={otherTiersAccounts} />

           

            <Typography variant="body2" color="text.secondary">
              For <b>Payments via Credit Card, Debit Card, or Net Banking</b> in any Currency (USD, AED, INR, GBP, or others), please send a request specifying the desired 
              amount to: <Link to="mailto:gauravi@i-am-peacekeeper.com" className='cursor-pointer'>gauravi@i-am-peacekeeper.com</Link>.
            </Typography>

            <Typography variant="body2" color="text.secondary" mt={2}>
              We shall be provide you with a dedicated payment link.
            </Typography>

            <Typography variant="body2" color="text.secondary" mt={2}>
              For any further queries or assistance,  kindly contact: <br></br> 
              Gaurav on:  <Link
  href="https://wa.me/917506007533"
  target="_blank"
  rel="noopener noreferrer"
  underline="hover"
>+91-75060-07533, </Link>,  <Link to="mailto:gaurav@i-am-peacekeeper.com" className='cursor-pointer'>gaurav@i-am-peacekeeper.com</Link>
            </Typography>
          </Box>
        </Container>
      </Box> */}
      </Box>




    </>
  );
};

export default Events;
